import { put } from 'redux-saga/effects'

import { setProductInfoDrawerOpen, setCurrentProduct } from '../../actions/ux'

import {
  EXPANDABLE_DRAWER_MODE_PREVIEW,
} from '../../../helpers/const'

function* onProductInfoDrawerOpen(action) {
  const { params: { mode, productId } } = action.payload

  yield put(setCurrentProduct(productId))
  yield put(setProductInfoDrawerOpen(mode || EXPANDABLE_DRAWER_MODE_PREVIEW))
}

export default onProductInfoDrawerOpen
